import { FF_PUBLISH_SURVEY_PANEL } from '@wetransfer/transfer/constant/experiments';
import { getVariant } from '@wetransfer/transfer/modules/experiments';

import { localStorage_key_didSeePanel } from './constants';

export const shouldShowPublishSurvey = (): boolean =>
  Boolean(
    getVariant(FF_PUBLISH_SURVEY_PANEL) === 'on' &&
      !localStorage?.getItem(localStorage_key_didSeePanel)
  );
